import React from 'react';
import {useIsMaxSm} from 'features/auth/ui/AuthorizationSteps/useIsMaxSm';
import {Drawer} from 'shared/ui/Drawer';
import {PAYMENT_METHOD_OPTIONS, type ProfilePaymentMethod} from '../../model/paymentMethod';
import {PaymentMethodOption} from '../PaymentMethodOption';
import styles from './AddPaymentMethodDrawer.module.css';

export type AddPaymentMethodDrawerProps = {
	open: boolean;
	onClose: () => void;
	onSelect?: (method: ProfilePaymentMethod) => void;
};

export function AddPaymentMethodDrawer({
	open,
	onClose,
	onSelect,
}: AddPaymentMethodDrawerProps): React.ReactElement {
	const isMaxSm = useIsMaxSm();

	const handleSelect = (method: ProfilePaymentMethod) => {
		onSelect?.(method);
		onClose();
	};

	return (
		<Drawer
			open={open}
			onClose={onClose}
			title="Добавить способ получения оплат"
			showCloseButton
			closeButtonPosition="end"
			variant={isMaxSm ? 'fullscreen' : 'side'}
			bodyClassName={styles.drawerBody}
		>
			<div className={styles.list}>
				{PAYMENT_METHOD_OPTIONS.map((option) => (
					<PaymentMethodOption
						key={option.value}
						value={option.value}
						label={option.label}
						onSelect={handleSelect}
					/>
				))}
			</div>
		</Drawer>
	);
}
